import React from 'react';
import { Skeleton, Stack } from '@mui/material';
import { breakpoints } from '@web-for-marketing/react-ui';

export const classes = {
    cardContainer: {
        width: '100%',
        outline: 'none',
    },
    picture: {
        width: '100%',
        borderRadius: '0.8rem',
        overflow: 'hidden',
        height: '24rem',
        [`@media (max-width: ${breakpoints.sm})`]: {
            height: '21rem',
        },
    },
    pillSkeleton: {
        borderRadius: '10rem',
        marginTop: '0.8rem',
    },
    cardContent: {
        padding: '0  1.6rem 1.6rem 1.6rem',
    },
} as const;

export interface SkeletonCardProps {
    className?: string;
}

export function SkeletonCard1({className}: SkeletonCardProps): React.ReactElement {
    return (
        <div css={classes.cardContainer} className={className}>
            <Skeleton variant='rectangular' width='100%' height='200px' css={classes.picture} />
            <div css={classes.cardContent}>
                <Stack>
                    <Skeleton variant='rectangular' width={60} height={32} css={classes.pillSkeleton} />
                    <Skeleton variant='text' width='100%' height={28} />
                    <Skeleton variant='text' width='100%' height={28} />
                    <Skeleton variant='text' width='40%' height={24} />
                </Stack>
            </div>
        </div>
    );
}